import { isNumber } from 'angular';
export var SharePageDirective = [
    '$timeout',
    'lightbox',
    function ($timeout, lightbox) {
        var hoverClass = 'hover';
        return {
            link: function ($scope, $element) {
                var hoverTimeout;
                $scope.lightbox = lightbox;
                if ($scope.showRound === true) {
                    $element.find('cg-icon').addClass("cg-icon-rounded cg-icon-rounded-size-" + $scope.roundSize);
                }
                if (isNumber($scope.size)) {
                    $element.find('cg-icon').addClass("cg-icon-size-" + $scope.size);
                }
                $element.on('mouseover', function () {
                    $element.addClass(hoverClass);
                    $timeout.cancel(hoverTimeout);
                });
                $element.on('mouseout', function () {
                    hoverTimeout = $timeout(function () {
                        $element.removeClass(hoverClass);
                    }, 500);
                });
                $scope.$on('$destroy', function () {
                    $element.removeClass(hoverClass);
                    $element.off('click hover');
                });
            },
            restrict: 'E',
            scope: {
                hideText: '<',
                showRound: '<?',
                size: '<?',
                roundSize: '<?',
            },
            templateUrl: 'compatibilityguide/ng-templates/feature/sharing/sharepage',
        };
    },
];
